/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_TitleInputs */

const tr_kullanim_title = /** @type {(inputs: Kullanim_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanım Koşulları`)
};

const en_kullanim_title = /** @type {(inputs: Kullanim_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Use`)
};

const de_kullanim_title = /** @type {(inputs: Kullanim_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzungsbedingungen`)
};

const ru_kullanim_title = /** @type {(inputs: Kullanim_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Условия использования`)
};

/**
* | output |
* | --- |
* | "Terms of Use" |
*
* @param {Kullanim_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_title = /** @type {((inputs?: Kullanim_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_title(inputs)
	if (locale === "de") return de_kullanim_title(inputs)
	if (locale === "ru") return ru_kullanim_title(inputs)
	return tr_kullanim_title(inputs)
});